/* eslint-disable no-use-before-define */
import AuditService from '../../services/AuditService';
import AuditTypes from '../types/AuditTypes';

//* get all department list items
function getAll(pageOption, type, date, rangeDate, user, module, keyword) {
  return async (dispatch) => {
    dispatch({ type: AuditTypes.GET_AUDIT_TRAIL_LIST_REQUEST });
    try {
      const res = await AuditService.getAll(
        pageOption,
        type,
        date,
        rangeDate,
        user,
        module,
        keyword
      );
      dispatch({
        type: AuditTypes.GET_AUDIT_TRAIL_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: AuditTypes.GET_AUDIT_TRAIL_LIST_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getItem(code) {
  return async (dispatch) => {
    dispatch({ type: AuditTypes.GET_AUDIT_TRAIL_ITEM_REQUEST });
    try {
      const res = await AuditService.getItem(code);
      dispatch({
        type: AuditTypes.GET_AUDIT_TRAIL_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: AuditTypes.GET_AUDIT_TRAIL_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getFilterModule(code) {
  return async (dispatch) => {
    dispatch({ type: AuditTypes.GET_AUDIT_MODULE_REQUEST });
    try {
      const res = await AuditService.getFilterModule(code);
      dispatch({
        type: AuditTypes.GET_AUDIT_MODULE_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: AuditTypes.GET_AUDIT_MODULE_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getFilterUser(code) {
  return async (dispatch) => {
    dispatch({ type: AuditTypes.GET_AUDIT_USER_REQUEST });
    try {
      const res = await AuditService.getFilterUser(code);
      dispatch({
        type: AuditTypes.GET_AUDIT_USER_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: AuditTypes.GET_AUDIT_USER_ERROR,
          error: error.response
        });
      }
    }
  };
}
const AuditAction = {
  getAll,
  getItem,
  getFilterModule,
  getFilterUser
};

export default AuditAction;
